<div class="page-wrapper">
  <div class="breadcrumbs">
    <a href="" (click)="$event.preventDefault(); goBack()">← Back to Ideas</a>
  </div>
  <div class="layout">
    <main class="main">
      <ng-container *ngIf="idea; else loadingOrError">
        <div class="card title-card">
          <h1 class="title">{{ idea.title }}</h1>
          <div class="tags">
            <span class="tag tag-category">{{ idea.category?.name || 'Uncategorized' }}</span>
            <span *ngIf="idea.challengeTitle" class="tag tag-challenge">{{ idea.challengeTitle }}</span>
            <span class="tag tag-status">{{ getStatusLabel(idea.status) }}</span>
          </div>
        </div>

        <section class="card">
          <h2>Description</h2>
          <p class="desc" *ngIf="idea.description; else noDesc">{{ idea.description }}</p>
          <ng-template #noDesc><p class="muted">No description provided.</p></ng-template>
        </section>

        <section class="card">
          <h2>Problem / Opportunity</h2>
          <p class="desc" *ngIf="idea.problemOpportunity; else noProblemOpp">{{ idea.problemOpportunity }}</p>
          <ng-template #noProblemOpp><p class="muted">Not specified.</p></ng-template>
        </section>

        <section class="card">
          <h2>Proposed Solution</h2>
          <p class="desc" *ngIf="idea.proposedSolution; else noSolution">{{ idea.proposedSolution }}</p>
          <ng-template #noSolution><p class="muted">Not specified.</p></ng-template>
        </section>

        <!-- <section class="card">
          <h2>Impact Scope</h2>
          <ng-container *ngIf="getImpactScopeLabels(idea.impactScope).length; else noScope">
            <ul class="impact-list">
              <li *ngFor="let s of getImpactScopeLabels(idea.impactScope)">{{ s }}</li>
            </ul>
          </ng-container>
          <ng-template #noScope><p class="muted">Not specified.</p></ng-template>
        </section> -->

        <section class="card">
          <h2>Expected Impact</h2>
          <ng-container *ngIf="getExpectedImpactLabels(idea.expectedImpactType).length; else noImpact">
            <ul class="impact-list">
              <li *ngFor="let i of getExpectedImpactLabels(idea.expectedImpactType)">{{ i }}</li>
            </ul>
          </ng-container>
          <ng-template #noImpact><p class="muted">Not specified.</p></ng-template>
        </section>

        <section class="card" *ngIf="hasDeliveredAttachments(idea)">
          <div class="deliverables-header">
            <div>
              <h2>Delivered Attachments</h2>
              <p class="deliverables-subtitle">Download the files shared with this delivered idea.</p>
            </div>
          </div>
          <p *ngIf="deliverableError" class="deliverables-error" role="alert">{{ deliverableError }}</p>
          <div class="deliverables-list" *ngIf="deliverableAttachments(idea).length; else noDeliverables">
            <button
              *ngFor="let attachment of deliverableAttachments(idea)"
              type="button"
              class="deliverable-item"
              (click)="downloadDeliverable(idea.id, attachment)"
              [disabled]="downloadingAttachmentId === attachment.id"
            >
              <div class="deliverable-item-main">
                <span class="deliverable-name">{{ attachment.fileName }}</span>
                <span class="deliverable-badge">{{ isImageAttachment(attachment) ? 'Image' : 'File' }}</span>
              </div>
              <div class="deliverable-item-meta">
                {{ formatFileSize(attachment.fileSizeBytes) }} • {{ formatDate(attachment.uploadedAtUtc) }}
              </div>
            </button>
          </div>
          <ng-template #noDeliverables>
            <p class="muted">No delivered attachments yet.</p>
          </ng-template>
        </section>

        <section class="card comments-section">
          <h2 class="comments-title">Comments ({{ comments.length }})</h2>
          <button
            *ngIf="!commentComposerOpen"
            type="button"
            class="comment-composer-toggle"
            (click)="openCommentComposer()"
          >
            Add a comment
          </button>
          <div *ngIf="commentComposerOpen" class="comment-input">
            <!-- <button type="button" class="comment-type-pill" aria-label="Comment type">
              <svg class="pill-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16"><path d="M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1zm3-19C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7z"/></svg>
              Suggestion
              <svg class="pill-arrow" viewBox="0 0 24 24" fill="currentColor" width="14" height="14"><path d="M7 10l5 5 5-5z"/></svg> -->
            <!-- </button> -->
            <textarea
              [(ngModel)]="commentBody"
              placeholder="Share your thoughts..."
              rows="3"
              [disabled]="postingComment"
            ></textarea>
            <button
              class="btn-post"
              (click)="postComment()"
              [disabled]="!commentBody?.trim() || postingComment"
            >
              <svg class="btn-icon" viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/></svg>
              Post Comment
            </button>
            <button
              type="button"
              class="btn-comment-cancel btn-comment-cancel-inline"
              (click)="closeCommentComposer()"
              [disabled]="postingComment"
            >
              Cancel
            </button>
          </div>
          <div class="comments-list" *ngIf="commentRows.length; else noComments">
            <article
              *ngFor="let row of commentRows"
              class="comment"
              [class.comment-nested]="row.depth > 0"
              [style.--comment-indent]="(row.depth * 38) + 'px'"
            >
              <ng-container *ngIf="row.comment as c">
              <div class="comment-header">
                <div class="comment-avatar">{{ getInitials(c.userDisplayName) }}</div>
                <div class="comment-content">
                  <div *ngIf="editingCommentId !== c.id" class="comment-bubble">
                    <strong class="comment-author">{{ c.userDisplayName }}</strong>
                    <p class="comment-body">{{ c.body }}</p>
                  </div>
                  <div *ngIf="editingCommentId === c.id" class="comment-edit">
                    <textarea
                      [(ngModel)]="editCommentBody"
                      rows="3"
                      class="comment-edit-input"
                      [disabled]="updatingCommentId === c.id"
                    ></textarea>
                    <div class="comment-edit-actions">
                      <button
                        type="button"
                        class="btn-comment-save"
                        (click)="saveEditComment()"
                        [disabled]="!editCommentBody?.trim() || updatingCommentId === c.id"
                      >
                        {{ updatingCommentId === c.id ? 'Saving…' : 'Save' }}
                      </button>
                      <button
                        type="button"
                        class="btn-comment-cancel"
                        (click)="cancelEditComment()"
                        [disabled]="updatingCommentId === c.id"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                  <div class="comment-footer" *ngIf="editingCommentId !== c.id">
                    <span class="comment-date">{{ formatDate(c.createdAtUtc) }}</span>
                    <span *ngIf="c.updatedAtUtc" class="comment-edited">Edited</span>
                    <div class="comment-actions">
                      <button
                        type="button"
                        class="btn-comment-action"
                        (click)="startReply(c)"
                        *ngIf="isAuthenticated"
                        [disabled]="!!updatingCommentId || !!commentPendingDelete || postingReply || postingComment"
                      >
                        Reply
                      </button>
                      <ng-container *ngIf="isCommentOwner(c)">
                      <button
                        type="button"
                        class="btn-comment-action"
                        (click)="startEditComment(c)"
                        [disabled]="!!updatingCommentId || !!commentPendingDelete"
                      >
                        Edit
                      </button>
                      <button
                        type="button"
                        class="btn-comment-action btn-comment-danger"
                        (click)="openDeleteCommentDialog(c)"
                        [disabled]="!!updatingCommentId || !!commentPendingDelete"
                      >
                        Delete
                      </button>
                      </ng-container>
                    </div>
                  </div>
                  <div *ngIf="replyingToCommentId === c.id" class="comment-reply">
                    <textarea
                      [(ngModel)]="replyBody"
                      rows="2"
                      class="comment-reply-input"
                      placeholder="Write a reply..."
                      [disabled]="postingReply"
                    ></textarea>
                    <div class="comment-reply-actions">
                      <button
                        type="button"
                        class="btn-comment-save"
                        (click)="postReply(c.id)"
                        [disabled]="!replyBody?.trim() || postingReply"
                      >
                        {{ postingReply ? 'Posting…' : 'Post Reply' }}
                      </button>
                      <button type="button" class="btn-comment-cancel" (click)="cancelReply()" [disabled]="postingReply">
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              </ng-container>
            </article>
          </div>
          <ng-template #noComments>
            <p class="no-comments-msg">No comments yet. Be the first to share your thoughts!</p>
          </ng-template>
        </section>
      </ng-container>

      <ng-template #loadingOrError>
        <div *ngIf="errorMessage" class="card error" role="alert">{{ errorMessage }}</div>
        <div *ngIf="loading" class="card idea-details-loader-card">
          <app-loader label="Loading idea" size="lg"></app-loader>
        </div>
      </ng-template>
    </main>

    <aside class="sidebar" *ngIf="idea">
      <div class="card">
        <h3>Cast Your Vote</h3>
        <div class="vote-buttons">
          <button
            class="vote-btn upvote"
            [class.active]="idea.hasVoted"
            (click)="toggleVote()"
            [disabled]="savingVote"
          >
            <svg class="vote-icon" viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2z"/></svg>
            {{ idea.upvoteCount ?? idea.voteCount ?? 0 }}
          </button>
          <button
            class="vote-btn downvote"
            [class.active]="idea.hasDownvoted ?? false"
            (click)="toggleDownvote()"
            [disabled]="savingVote"
          >
            <svg class="vote-icon" viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2zm4 0v12h4V3h-4z"/></svg>
            {{ getDownvoteCount() }}
          </button>
        </div>
        <button
          class="btn-follow"
          [class.following]="idea.isFollowing"
          (click)="toggleFollow()"
          [disabled]="following"
        >
          <svg class="follow-icon" viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>
          {{ idea.isFollowing ? 'Following' : 'Follow' }}
        </button>
      </div>

      <div class="card">
        <h3>Want to Help?</h3>
        <p class="help-text">Offer your skills and availability to support this idea</p>
        <button
          class="btn-help"
          [class.helping]="idea.isHelping"
          (click)="onHelpButtonClick()"
          [disabled]="helping"
        >
          {{ idea.isHelping ? 'Helping' : 'I Can Help' }}
        </button>
      </div>

      <div class="card" *ngIf="idea.helpers?.length">
        <h3>People Who Can Help</h3>
        <div class="helpers-list" role="list">
          <div
            *ngFor="let helper of idea.helpers"
            class="helper-avatar"
            [attr.title]="helper.displayName"
            role="listitem"
            [attr.aria-label]="helper.displayName"
          >
            {{ helperInitials(helper) }}
            <span class="helper-name-tooltip" aria-hidden="true">{{ helper.displayName }}</span>
          </div>
        </div>
      </div>

      <div class="card">
        <h3>Idea Details</h3>
        <dl class="details">
          <div class="detail-row">
            <dt>
              <svg class="detail-icon" viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/></svg>
              Submitted by
            </dt>
            <dd>{{ idea.submitAnonymously ? 'Anonymous' : (idea.ownerDisplayName || 'Unknown') }}</dd>
          </div>
          <div class="detail-row">
            <dt>
              <svg class="detail-icon" viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11z"/></svg>
              Created
            </dt>
            <dd>{{ idea.createdAtUtc ? formatDate(idea.createdAtUtc) : '—' }}</dd>
          </div>
          <div class="detail-row">
            <dt>
              <svg class="detail-icon" viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"/></svg>
              Impact Scope
            </dt>
            <dd>{{ getImpactScopeDisplay(idea.impactScope) }}</dd>
          </div>
          <div class="detail-row">
            <dt>
              <svg class="detail-icon" viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2Zm1 15h-2v-2h2Zm0-4h-2V7h2Z"/></svg>
              Effort
            </dt>
            <dd>{{ idea.estimatedEffort || '—' }}</dd>
          </div>
          <div class="detail-row" *ngIf="idea.challengeTitle">
            <dt>
              <svg class="detail-icon" viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M19 5h-2V3H7v2H5c-1.1 0-2 .9-2 2v1c0 2.55 1.92 4.63 4.39 4.94.63 1.5 1.98 2.63 3.61 2.96V19H7v2h10v-2h-2v-3.1c1.63-.33 2.98-1.46 3.61-2.96C19.08 12.63 21 10.55 21 8V7c0-1.1-.9-2-2-2z"/></svg>
              Challenge
            </dt>
            <dd>{{ idea.challengeTitle }}</dd>
          </div>
          <div class="detail-row">
            <dt>
              <svg class="detail-icon" viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M12 2 2 7l10 5 10-5-10-5Zm0 7L2 4v13l10 5 10-5V4l-10 5Z"/></svg>
              Owner Dept
            </dt>
            <dd>{{ idea.ownerDepartment || '—' }}</dd>
          </div>
          <div class="detail-row" *ngIf="idea.tags?.length">
            <dt>
              <svg class="detail-icon" viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M20.59 13.41 11 3.83A2 2 0 0 0 9.59 3H4a1 1 0 0 0-1 1v5.59A2 2 0 0 0 3.83 11l9.58 9.59a2 2 0 0 0 2.83 0l4.35-4.35a2 2 0 0 0 0-2.82ZM7.5 7A1.5 1.5 0 1 1 9 5.5 1.5 1.5 0 0 1 7.5 7Z"/></svg>
              Tags
            </dt>
            <dd>{{ idea.tags?.join(', ') }}</dd>
          </div>
        </dl>
      </div>

      <div class="card activity-timeline-card">
        <h3 class="activity-timeline-heading">
          <svg
            class="activity-timeline-icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
          </svg>
          Activity Timeline
        </h3>
        <app-loader *ngIf="timelineLoading" [inline]="true" size="sm" label="Loading activity"></app-loader>
        <ul *ngIf="!timelineLoading" class="activity-timeline-list" role="list">
          <li
            *ngFor="let row of timelineDisplay; trackBy: trackTimelineRow"
            class="activity-timeline-item"
          >
            <div class="activity-timeline-gutter">
              <span class="activity-timeline-dot" aria-hidden="true"></span>
            </div>
            <div class="activity-timeline-body">
              <div class="activity-timeline-title">{{ row.title }}</div>
              <div class="activity-timeline-meta">{{ formatDate(row.atIso) }}</div>
            </div>
          </li>
        </ul>
      </div>
    </aside>
  </div>

  <div
    *ngIf="helpConfirmationOpen"
    class="delete-comment-overlay"
    (click)="closeHelpConfirmation()"
    role="dialog"
    aria-modal="true"
    aria-labelledby="help-confirm-title"
  >
    <div class="delete-comment-dialog" (click)="$event.stopPropagation()">
      <h2 id="help-confirm-title" class="delete-comment-title">Confirm helping this idea?</h2>
      <p class="delete-comment-message">
        You will be added to the list of people who can help support this idea.
      </p>
      <div class="delete-comment-actions">
        <button
          type="button"
          class="delete-comment-btn-cancel"
          (click)="closeHelpConfirmation()"
          [disabled]="helping"
        >
          Cancel
        </button>
        <button
          type="button"
          class="delete-comment-btn-delete help-confirm-btn"
          (click)="confirmHelp()"
          [disabled]="helping"
        >
          {{ helping ? 'Saving…' : 'Yes, I Can Help' }}
        </button>
      </div>
    </div>
  </div>

  <div
    *ngIf="commentPendingDelete as pending"
    class="delete-comment-overlay"
    (click)="closeDeleteCommentDialog()"
    role="dialog"
    aria-modal="true"
    aria-labelledby="delete-comment-title"
  >
    <div class="delete-comment-dialog" (click)="$event.stopPropagation()">
      <h2 id="delete-comment-title" class="delete-comment-title">Delete this comment?</h2>
      <p class="delete-comment-message">This will remove your comment permanently. You cannot undo this action.</p>
      <div class="delete-comment-actions">
        <button
          type="button"
          class="delete-comment-btn-cancel"
          (click)="closeDeleteCommentDialog()"
          [disabled]="deletingCommentId === pending.id"
        >
          Cancel
        </button>
        <button
          type="button"
          class="delete-comment-btn-delete"
          (click)="confirmDeleteComment()"
          [disabled]="deletingCommentId === pending.id"
        >
          {{ deletingCommentId === pending.id ? 'Deleting…' : 'Delete' }}
        </button>
      </div>
    </div>
  </div>
</div>
